const {
  GLOBAL_PERMISSIONS,
  ACCOUNT_PERMISSIONS,
  DATA_SOURCE_PERMISSIONS,
} = require('../constants/permissions');

const globalPermissionValues = new Set(Object.values(GLOBAL_PERMISSIONS));
const customerPermissionValues = new Set(Object.values(ACCOUNT_PERMISSIONS));
const dataSourcePermissionValues = new Set(Object.values(DATA_SOURCE_PERMISSIONS));

const permissionOptions = [
  { value: '', label: 'None (visible to all)' },
  ...Object.values(GLOBAL_PERMISSIONS).map((permission) => ({
    value: permission,
    label: `Global: ${permission}`,
  })),
  ...Object.values(ACCOUNT_PERMISSIONS).map((permission) => ({
    value: permission,
    label: `Account: ${permission}`,
  })),
  ...Object.values(DATA_SOURCE_PERMISSIONS).map((permission) => ({
    value: permission,
    label: `Data source: ${permission}`,
  })),
];

function checkPermission(permission, {
  hasPermission,
  hasCustomerPermission,
  hasDataSourcePermission,
}) {
  if (!permission) {
    return true;
  }

  if (globalPermissionValues.has(permission)) {
    return hasPermission(permission);
  }

  if (customerPermissionValues.has(permission)) {
    return hasCustomerPermission(permission);
  }

  if (dataSourcePermissionValues.has(permission)) {
    return hasDataSourcePermission(permission);
  }

  return hasPermission(permission)
    || hasCustomerPermission(permission)
    || hasDataSourcePermission(permission);
}

module.exports = {
  permissionOptions,
  checkPermission,
};
